export default __webpack_public_path__ + "static/media/cabourg13.0b954d88.jpg";